import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nurse-point-sale-register-patient-update',
  templateUrl: './nurse-point-sale-register-patient-update.component.html',
  styleUrls: ['./nurse-point-sale-register-patient-update.component.css']
})
export class NursePointSaleRegisterPatientUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
